import React from 'react';
import * as style from './Header.module.css';
import { DataContext } from '../DataProvider';

import FlightRow from '../FlightRow';

import styled from 'styled-components';

function Header() {
  const { flights, setApiWasRequested, setRequestWasHandled } =
    React.useContext(DataContext);

  // function handleClick() {
  //   console.log('handling click');
  //   setApiWasRequested(true);
  //   setRequestWasHandled(false);
  // }

  return (
    <>
      <header>
        <h1>Flights</h1>
      </header>
      <main>
        <ul class='flight-list'>
          {flights.map((flight) => {
            console.log(flight);
            return <FlightRow data={flight} />;
          })}
        </ul>
      </main>
    </>
  );
}

export default Header;
